import React from 'react';

import PropTypes from 'prop-types';

export const oi = ({ fillColor }) => (
    <svg version='1.1' viewBox='0 0 612 528' xmlns='http://www.w3.org/2000/svg'>
        <g>
            <path
                fill={fillColor}
                d='M568.7,310.3c0,83.3-109,186.3-251.2,186.3c-155.6,0-283-90.6-283-241.1 c0-103.1,69.7-224.1,202.1-224.1c117.9,0,161.7,82.8,219,120.8C519.5,194.5,568.7,232.2,568.7,310.3z'
            />
            <path
                fill='#fff'
                d='M349.5,215.4c11.9,0,21.5-9.6,21.5-21.5c0-11.8-9.6-21.5-21.5-21.5c-11.8,0-21.4,9.6-21.4,21.5 C328,205.8,337.6,215.4,349.5,215.4z M349.8,231.3c-12.1,0-21.9,28.7-21.9,64.1c0,35.4,9.8,64.1,21.9,64.1 c12.1,0,21.9-28.7,21.9-64.1C371.6,260,361.8,231.3,349.8,231.3z M252.3,231.2c-36,0-59.9,28.5-59.9,64.1 c0,35.7,23.9,64.1,59.9,64.1c35.9,0,59.7-28.4,59.7-64.1C312,259.7,288.1,231.2,252.3,231.2z M252.3,329.3 c-16.5,0-25.6-16.9-25.6-34.1c0-17.2,9.1-33.6,25.6-33.6c16.4,0,25.5,16.5,25.5,33.6C277.8,312.3,268.7,329.3,252.3,329.3z'
            />
        </g>
    </svg>
);

oi.propTypes = {
    fillColor: PropTypes.string.isRequired
};

export default oi;
